/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { editPreference } from '../../store/modules/student/actions'

import Content from './components/Content'
import FirstAccessModal from '../../components/FirstAccessModal'
import FormatModal from '../../components/FormatModal'
import { learningApi } from '../../services/api'
import { RootState } from '../../store/modules/rootReducer'
import { toast } from 'react-toastify'
import FinalLessonModal from '../../components/FinalLessonModal'
import history from '../../services/history'
import ContentLoader from 'react-content-loader'
import queryString from 'query-string'
import { changeRecentView } from '../../store/modules/recentView/action'
import Layout from './components/Layout'
import { LessonBetaProps } from './types'
import { useGetMenuContent } from './hooks/use-get-menu-content'
import { useGetLesson } from './hooks/use-get-lesson'
import Banner from './components/Banner'
import { LessonContextProvider } from './context'
import ModalFreemium from 'components/ModalFreemium'
import { WrapperContainer } from '../../pages/Course/components/ModuleAcordeon/styles'
import Direcao from '../../assets/logos/direcao-square.png'

const Lesson: React.FC<LessonBetaProps> = ({
  match: {
    params: { courseId, lessonId, moduleId, chapterId },
  },
}) => {
  const { profile } = useSelector((state: RootState) => state.student)
  const dispatch = useDispatch()
  const [openChangePreference, setOpenChangePreference] = useState<boolean>(false)

  const token = localStorage.getItem('token')
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const [object, setObject] = useState<any>()

  const [openFinalLessonModal, setOpenFinalLesson] = useState<boolean>(false)
  const [openModalFreemium, setOpenModalFreemium] = useState<boolean>(false)

  const swrMenuContent = useGetMenuContent({ courseId, moduleId })
  const swrLesson = useGetLesson({ courseId, moduleId, chapterId, lessonId })

  const course = swrMenuContent.isLoading && !swrLesson.error ? null : swrMenuContent.data?.course
  const module = swrMenuContent.isLoading ? null : swrMenuContent.data?.module

  const lesson = swrLesson.isLoading && !swrLesson.error ? null : swrLesson.data
  const chapter = swrLesson.isLoading && !swrLesson.error ? null : swrLesson.data?.chapter
  const contents = swrLesson.isLoading && !swrLesson.error ? [] : swrLesson.data?.contents

  const isFirstChapter = swrLesson.isLoading && !swrLesson.error ? false : chapter?.isFirst
  const isLastChapter = swrLesson.isLoading && !swrLesson.error ? false : chapter?.isLast
  const next =
    swrLesson.isLoading && !swrLesson.error
      ? null
      : { chapter: chapter?.next, lesson: lesson?.next }
  const types = swrLesson.isLoading && !swrLesson.error ? [] : swrLesson.data?.chapter?.types
  const previous =
    swrLesson.isLoading && !swrLesson.error
      ? null
      : { chapter: chapter?.previous, lesson: lesson?.previous }
  const loading = swrLesson.isLoading
  const { search: searchParams } = window.location
  const contentTypeByParams = queryString.parse(searchParams)?.type

  const globalLoading = swrMenuContent.isLoading || swrLesson.isLoading

  // Futuramente transformar esse componente como um componente compartilhado
  const RenderModalFreemium = () => {
    const moduleInfo = {
      _id: module?._id,
      name: module.name,
      icon: course.icon ?? Direcao,
      discount: module.discount,
      permanentLink: module.permanentLink,
      qtd_videos: module.total.video?.amount,
      qtd_pdf: module.total.excerto?.amount,
    }

    const courseInfo = {
      _id: course?._id,
      name: course.name,
      icon: course.icon ?? Direcao,
      discount: course.discount,
      permanentLink: course.permanentLink,
      qtd_videos: course.totalCourse.videos?.amount,
      qtd_pdf: course.totalCourse.excertos?.amount,
    }

    return (
      <WrapperContainer>
        <ModalFreemium
          module={moduleInfo}
          course={courseInfo}
          subscription={course?.isFreemium && course?.isSubscription}
          setOpenModal={setOpenModalFreemium}
        />
      </WrapperContainer>
    )
  }

  useEffect(() => {
    if (contentTypeByParams) {
      dispatch(changeRecentView(courseId))
    }
  }, [contentTypeByParams, courseId, dispatch])

  const handleChangePreference = async (preference: 'video' | 'text') => {
    const format = preference === 'text' ? 1 : 0

    if (format !== profile.preference) {
      dispatch(editPreference(format))

      setOpenChangePreference(true)

      await learningApi.put(
        '/student/preferences/',
        { objectType: format },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      setOpenChangePreference(false)
    }
  }

  const handleContentNavigate = useCallback(
    (type: 'previous' | 'next' | 'next_lesson') => {
      if (type === 'next' && isLastChapter) {
        if (course.isFreemium && !course.isSubscription) {
          return setOpenModalFreemium(true)
        }
        return setOpenFinalLesson(true)
      }

      if (type === 'previous')
        return history.push(
          `/course/${courseId}/module/${moduleId}/lesson/${
            isFirstChapter ? previous.lesson._id : lessonId
          }/chapter/${previous.chapter._id}`
        )

      if (type === 'next')
        return history.push(
          `/course/${courseId}/module/${moduleId}/lesson/${
            isLastChapter ? next.lesson._id : lessonId
          }/chapter/${next.chapter._id}`
        )

      if (type === 'next_lesson') {
        setOpenFinalLesson(false)
        if (!next?.lesson?._id) {
          return history.push(`/course/${courseId}`)
        } else {
          return history.push(
            `/course/${courseId}/module/${moduleId}/lesson/${next.lesson._id}/chapter/${next.chapter._id}`
          )
        }
      }
    },
    [courseId, moduleId, lessonId, next, previous, isFirstChapter, isLastChapter]
  )

  const handleInitMonitoring = useCallback(async () => {
    const type =
      types?.includes('excerto') && types?.includes('video')
        ? 'excerto'
        : types?.every((t) => t === 'excerto')
        ? 'excerto'
        : types?.every((t) => t === 'video')
        ? 'video'
        : null

    if (types?.length && type && chapter?._id === chapterId) {
      await learningApi
        .post(
          '/content/monitoring/initialize',
          {
            chapter: chapterId,
            course: courseId,
            module: moduleId,
            lesson: lessonId,
            type: type.toLowerCase(),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .catch((err) => {
          if (err.response?.status === 401) return

          console.error(err)
          toast.error('Falha ao inicializar o conteúdo!')
        })
    }
  }, [courseId, moduleId, lessonId, chapterId, token, types, chapter])

  useEffect(() => {
    handleInitMonitoring()
  }, [handleInitMonitoring, chapterId])

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <LessonContextProvider swrLesson={swrLesson} swrMenuContent={swrMenuContent}>
      <Layout>
        <Banner
          course={course}
          module={module}
          lesson={lesson}
          chapter={chapter}
          types={types}
          professores={chapter?.professores}
          loading={loading}
          contents={contents}
          object={object}
        />
        {globalLoading ? (
          <ContentLoader
            width={window.innerWidth < 800 ? '100%' : '95%'}
            height={500}
            viewBox={'0 0 100% 100%'}
            {...LoaderProps}
          >
            <rect
              x={window.innerWidth < 800 ? '20' : '65'}
              y="20"
              rx="15"
              ry="15"
              width={window.innerWidth < 800 ? '90%' : '95%'}
              height="400"
            />
          </ContentLoader>
        ) : (
          <Content
            setObject={setObject}
            handleContentNavigate={handleContentNavigate}
            handleChangePreference={handleChangePreference}
            preference={
              contentTypeByParams
                ? contentTypeByParams
                : profile.preference === 1
                ? 'text'
                : 'video'
            }
          />
        )}
        {lesson && profile.preference === null && (
          <FirstAccessModal handleChangePreference={handleChangePreference} />
        )}
        {openChangePreference && (
          <FormatModal isModeApresentation={profile.preference === 1 ? 'text' : 'video'} />
        )}
        {openModalFreemium && RenderModalFreemium()}
        <FinalLessonModal
          moduleName={module?.name}
          lessonName={lesson?.name}
          onClose={() => setOpenFinalLesson(false)}
          open={openFinalLessonModal}
          isFinalModule={false}
          handleContentNavigate={handleContentNavigate}
        />
      </Layout>
    </LessonContextProvider>
  )
}

export default Lesson
